<template>
    <div class="rav-img-thumb">
        <div class="image-container">
            <img
                v-img:rav="{src: img.url, title: img.title, opened: onOpened, closed: onClosed, changed: onChanged }"
                :src="img.urlthb"
                :title="img.title"
                @click="onClicked"
            >
        </div>
        <div class="image-caption">{{ img.title }}</div>
        <div
            class="rav-btn-select"
            @click="$emit('select-img', index)"
        >Sélectionner</div>
    </div>
</template>

<script>
import Vue from 'vue';
//-- Patch pour IE 11 Array.from
import "../helpers/IE11ArrayFrom.js"
//-- v-img : module galerie d'image vue
import VueImg from 'v-img';

const vueImgConfig = {
    // Use `alt` attribute as gallery slide title
    altAsTitle: false,
    // Display 'download' button near 'close' that opens source image in new tab
    sourceButton: false,
    // Event listener to open gallery will be applied to <img> element
    openOn: 'click',
    // changed: onChanged,
    // Show thumbnails for all groups with more than 1 image
    // thumbnails: true
};
Vue.use(VueImg, vueImgConfig);

export default {
  name: "RavImgElt",
  props: {
    index: Number,
    img: {
        type: Object,
        default: function() { return {} }
    }
  },
  /* data: () => {
      return {
          imgUrl: '',
          currentImg: ''
      }
  }, */
  methods: {
      onOpened: function() {
        //   console.log('RavImgElt > onOpened ! > ');
          this.$emit("slide-opened");
      },
      onClosed: function() {
        //   console.log('RavImgElt > onClosed ! > ');
          this.$emit("slide-closed", -1);
        //   this.$emit("slide-img-index", -1);
      },
      onChanged: function(pIndex) {
          console.log('RavImgElt > onChanged ! > ', pIndex);
          this.$emit("slide-img-index", pIndex);
      },
      onClicked: function() {
        // console.log('RavImgElt > onClicked ! > ', this.index);
        //   this.$emit("slide-opened");
        this.$emit("slide-img-index", this.index);
      }
  }
};
</script>

<style lang="scss">
.rav-img-thumb {
    border: 1px solid #dddddd;
    padding: 5px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    margin: 0 10px 10px 0;
    position: relative;
    display: inline-block;
    background-color: white;
    vertical-align: middle;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    border-radius: 2px;
    text-decoration: none;

    .image-container {
        display: table-cell;
        vertical-align: middle;
        height: 120px;
        background-color: black;

        img {
            width: 180px;
            display: block;
            // vertical-align: middle;
        }
    }

    .image-caption {
        color: #999999;
        text-align: center;
        white-space: nowrap;
        padding-top: 5px;
    }

    &:hover {
        border: 1px solid #aaaaaa;
        box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);

        .image-caption {
        color: #232323;
        }
    }
}
</style>